import { useState } from "react";
import Button from "src/components/Button";
import InitialsLogo from "src/components/InitialsLogo";
import Table from "src/components/Tables/Table";
import { sendReminder } from "src/network/interview";
import InterviewStatusTag from "src/pages/job/components/InterviewStatusTag";
import { JobInterview } from "src/types";
import { dateFormat1 } from "src/utils/dates/formats";
import { customToast } from "src/utils/toast";
import { InterviewTable } from "./type";

const InvitedTable = ({ data }: InterviewTable) => {
  const [reminding, setReminding] = useState<number>();
  const remind = async (id: number) => {
    setReminding(id);
    try {
      await sendReminder({ interview_id: id });
      const inter = data?.find((i) => i.id === id);
      if (inter) {
        inter.reminded_at = new Date().toString();
        inter.reminded_recently = true;
      }
      customToast({ message: "Reminder sent", type: "success" });
    } catch (e) {
      console.error(e);
      customToast({ message: "Error sending reminder" });
    }
    setReminding(undefined);
  };
  return (
    <Table
      data={data}
      className="overflow-x-scroll"
      heads={[
        "Name | Email Address",
        "Recruiter",
        "Status",
        "Invite Date | Last Reminder Sent",
        "Action"
      ]}
      row={(i: JobInterview) => {
        const {
          id,
          first_name,
          last_name,
          email,
          createdAt,
          Inviter,
          Interview,
          reminded_recently,
          reminded_at
        } = i;
        const lastRemind = reminded_at ? " | " + dateFormat1(reminded_at) : "";
        return [
          <div>
            <p>{`${first_name} ${last_name}`}</p>
            <p className="max-w-[207px] overflow-hidden text-ellipsis mt-2">{email}</p>
          </div>,
          Inviter ? <InitialsLogo user={Inviter.User} /> : "N/A",
          <InterviewStatusTag i={Interview} />,
          <p>{dateFormat1(createdAt) + lastRemind}</p>,
          <Button
            onClick={() => remind(id)}
            loading={reminding === id}
            className="!text-sm !rounded-3xl !w-[141px] !px-4"
            disabled={reminded_recently || (!!reminding && reminding !== id)}
          >
            Remind
          </Button>
        ];
      }}
    />
  );
};

export default InvitedTable;
